module.exports = __webpack_public_path__ + "static/media/access-options.0688d0d4.png";